<template>
<md-list-item>
    <div class="md-list-text-container">
        <span><strong>{{collaborator.name}}</strong></span>
        <span>{{collaborator.role}}</span>
        <span>{{collaborator.email}}</span>
    </div>
    <md-list-expand v-if="editable">
        <div class="button-row">
            <md-button @click="removeCollaborator">
                <md-icon>delete</md-icon>
                Remove
            </md-button>
            <md-button @click="resendInvitation" :disabled="isResending">
                <md-spinner v-if="isResending" :md-size="16" md-indeterminate></md-spinner>
                <md-icon v-else>email</md-icon>
                <span>{{ isResending ? 'Sending...' : 'Resend Invitation' }}</span>
            </md-button>
        </div>
    </md-list-expand>
</md-list-item>
</template>

<script>

const CollaboratorsPendingCollaborator = {
    name: 'CollaboratorsPendingCollaborator',
    props: ['collaborator', 'editable', 'layers'],
    data: function() {
        return {
            editing: false,
            isResending: false
        };
    },
    methods: {
        removeCollaborator() {
            this.$emit('removePendingCollaborator', this.collaborator.id);
        },
        async resendInvitation() {
            this.isResending = true;
            try {
                await this.$emit('resendInvitation', this.collaborator);
            } finally {
                setTimeout(() => {
                    this.isResending = false;
                }, 2000);
            }
        }
    }
};
export default CollaboratorsPendingCollaborator;
</script>

<style>
.button-row {
    display: flex;
    gap: 8px;
    align-items: center;
}
</style>


// WEBPACK FOOTER //
// pending-collaborator.vue?66488f48